import { render, staticRenderFns } from "./BankConfigureCtepBankTypePerBrandSettingsEditModal.vue?vue&type=template&id=28954ff2&scoped=true"
import script from "./BankConfigureCtepBankTypePerBrandSettingsEditModal.vue?vue&type=script&lang=ts"
export * from "./BankConfigureCtepBankTypePerBrandSettingsEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28954ff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28954ff2')) {
      api.createRecord('28954ff2', component.options)
    } else {
      api.reload('28954ff2', component.options)
    }
    module.hot.accept("./BankConfigureCtepBankTypePerBrandSettingsEditModal.vue?vue&type=template&id=28954ff2&scoped=true", function () {
      api.rerender('28954ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/BankConfigureCtepBankTypePerBrandSettingsEditModal.vue"
export default component.exports